<template>
  <div class="result page">
    <div class="result-bg page"></div>

    <!-- 刚制作完，到这个页面 -->
    <div class="page">
      <!-- 海报 -->
      <div class="poster-box">
        <canvas id="canvas" width="640" height="1120"></canvas>
        <img id="poster" :class="{'poster-cansave': this.$store.state.isIOS && this.$store.state.isSafari}" :src="poster" />
         <!-- crossOrigin="anonymous" -->
      </div>

      <!-- 预览框，用来生成canvas图片 -->
      <div id="preview-box">
        <img v-if="hasPrizeVersion" id="preview-bg" class="preview-bg" src="../assets/p8/bg-hasprize.jpg" />
        <img v-else id="preview-bg" class="preview-bg" src="../assets/p8/bg-noprize.jpg" />
        

        <div class="preview-head">
          <img :src="this.$store.state.wxUser.headimgurl" />
        </div>
        <div class="preview-name">{{this.$store.state.wxUser.nickname}}</div>

        <canvas id="radar" width="350" height="380"></canvas>

        <div class="preview-texts">
          <div v-for="(item,index) in this.$store.state.result" :class="'preview-text' + index" :key="index">
            <div class="preview-title">{{item.title}}</div>
            <div class="preview-content">{{item.content}}</div>
          </div>
        </div>
      </div>

      <!-- 音频按钮 -->
      <div class="player-btn player-btn-play" v-show="audioState==='play'" @click="audioPause"></div>
      <div class="player-btn player-btn-pause" v-show="audioState==='pause'" @click="audioPlay"></div>

      <!-- 底部按钮 -->
      <div class="content">
        <div v-if="hasPrizeVersion" class="choujiang-btn" @click="showLeadToShare"></div>
        <div v-else class="help-btn" @click="showLeadToShare"></div>
        <div class="retryr-btn" @click="reTry"></div>

        <div class="ai-logo" :class="{'anim-fade': once}"></div>
      </div>

      <!-- 引导分享 -->
      <transition name="fade">
        <div v-if="isShowLeadToShare" class="lead-to-share" @click="showLeadToShare">
          <img v-if="hasPrizeVersion" src="../assets/p5/share-hasprize.png" alt="" />
          <img v-else src="../assets/p5/share-noprize.png" alt="" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import queryString from 'query-string'
import drawRadar from '../../lib/drawRadar'
// import { updateShare } from '../../lib/wxShare'

export default {
  name: 'result',
  data: function () {
    return {
      name: '1',
      data: [],
      isShowLeadToShare: false,

      // 是否有抽奖的版本
      hasPrizeVersion: this.$store.state.hasPrizeVersion,
      
      // 生成的海拔的base64编码
      poster: '',
      
      // 语音合成
      audio: null,
      
      // 是否显示ai-logo动画
      once: true,

      // 音频播放状态
      audioState: 'pause'
    }
  },
  created () {
    // ye
  },
  mounted () {
    // 页面渲染完成，检查是否有shareId
    const self = this

    console.log('result mounted')

    // 页面渲染完成
    this.$store.commit('setPageReady')

    // 先绘制海报
    this.drawPoster()

    // 再加载音频
    this.loadAudio()
  },
  methods: {
    // 绘制雷达图
    drawRadar () {
      const canvas = document.getElementById('radar')
      const data = []
      
      // 识别结果的数据，组装一下
      this.$store.state.result.forEach( item => {
        data.push([item.title, item.value])
      })

      drawRadar(canvas, data, {
        
      })
    },

    // 绘制海报
    drawPoster () {
      const self = this
      // 先绘制雷达图
      this.drawRadar()

      const canvas = document.getElementById('canvas')
      const ctx = canvas.getContext('2d')

      const bg = document.getElementById('preview-bg')
      bg.onload = function () {
        ctx.drawImage(bg, 0, 0, 640, 1120)

        const headImage = new Image()
        headImage.setAttribute('crossorigin', 'anonymous')
        headImage.src = self.$store.state.wxUser.headimgurl
        headImage.onload = function () {
          ctx.drawImage(headImage, 40, 20, 85, 84)

          html2canvas(document.getElementById('preview-box'), {
            canvas: document.getElementById('canvas'),
            allowTaint: true,
            backgroundColor: null,
            scale: 1,
            width: 640,
            height: 1120
          }).then(canvas => {
            self.poster = canvas.toDataURL("image/jpeg")

            console.log('self.poster.length', self.poster.length)
          })
        }
      }
    },

    // 加载人工智能合成的音频
    loadAudio () {
      const self = this

      // 获取音频
      let audioText = '你解锁了政府工作报告这些内容：'
      this.$store.state.result.forEach(item => {
        audioText += item.title + '，'
        audioText += item.content
      })
      this.audio = btts({
        tex: audioText,
        tok: this.$store.state.tokens.baiduToken,
        spd: 5,
        pit: 5,
        vol: 15,
        per: 4
      }, {
        volume: 0.3,
        autoDestory: false,
        timeout: 10000,
        hidden: true,
        onInit: function (htmlAudioElement) {
          // console.log('音频初始化')
        },
        onSuccess: function(htmlAudioElement) {
          self.audio = htmlAudioElement;
          // console.log('音频初始化，成功')
        },
        onError: function(text) {
          // alert(text)
        },
        onTimeout: function () {
          // alert('timeout')
        }
      });
    },

    // 音频重置
    audioReset () {
      if(!this.audio) return;
      this.audio.pause()
      this.audio = null
    },

    // 音频播放按钮
    audioPlay () {
      if(!this.audio) return;
      // console.log('播放音频')
      this.audio.play()
      this.audioState = 'play'

      this.once = false
    },
    // 音频暂停按钮
    audioPause () {
      if(!this.audio) return;
      // console.log('暂停音频')
      this.audio.pause()
      this.audioState = 'pause'
    },

    // 助力赢好礼按钮
    showLeadToShare () {
      this.isShowLeadToShare = !this.isShowLeadToShare
    },

    // 再扫一次按钮
    reTry () {
      this.audioReset()

      // history.replaceState(history.state, '', location.pathname + '#/result')
      // let url = window.location.href
      // window.location.href = url
      this.$store.commit('clearShareId')

      this.$router.replace('upload')

      const player = document.getElementById('mp3-text')
      player.play()
    }
  }
}
</script>

<style scoped>
  .result{
    position: relative;
  }
  .result-bg{
    position: absolute;
    top: 0;
    left: 0;

    background-image: url(../assets/p4/bg.jpg);
    background-size: 100% auto;
    background-position: 50% 0;
    background-repeat: no-repeat;
    opacity: 0.85;
  }

  /* 海报区域 */
  .poster-box{
    position: absolute;
    top: 0;
    left: 1.38rem;
    z-index: 9;
    font-size: 0;
  }
  /* 实际存储海报内容的img */
  #poster{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    /* width: 16.19rem; */
    width: 18.5rem;
    height: 28.34rem;
    border: 0;
    vertical-align: top;
    outline: none;
    opacity: 0;
  }
  .poster-cansave{
    -webkit-touch-callout: default;
  }
  #canvas{
    width: 16.19rem!important;
    height: 28.34rem!important;
  }


  /* 用来生成canvas的dom */
  #preview-box{
    position: absolute;
    top: 0;
    left: -641px;
    /* z-index: 999;
    transform: scale3d(.5,.5,.5);
    transform-origin: 0 0; */

    width: 640px;
    height: 1120px;
    overflow: hidden;
  }
  .preview-bg{
    position: absolute;
    top: 0;
    left: 0;
    /* left: -641px; */

    width: 100%;
    /* opacity: 0; */
  }
  .preview-head{
    position: absolute;
    top: 20px;
    left: 37px;
    z-index: 2;

    border-radius: 12px;
    padding: 5px;
    width: 76px;
    height: 75px;
    background-color: #ffffff;
    background-image: url(../assets/p8/head-image-box.png);
    background-size: 100% 100%;
    font-size: 0;
  }
  .preview-head img{
    border-radius: 6px;
    vertical-align: top;
    width: 100%;
    height: 100%;
  }
  .preview-name{
    position: absolute;
    top: 62px;
    left: 132px;
    z-index: 2;

    line-height: 1;
    font-family: title_l;
    font-size: 26px;
    color: #1e3452;
  }

  /* 雷达图 */
  #radar{
    position: absolute;
    top: 294px;
    left: 252px;
    z-index: 2;

    width: 350px;
    height: 380px;
    /* background-color: rebeccapurple;
    opacity: .7; */
  }

  .preview-texts{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    text-align: left;
  }
  .preview-text0{
    position: absolute;
    top: 294px;
    left: 34px;

    width: 210px;
    height: 360px;
  }
  .preview-text1{
    position: absolute;
    top: 660px;
    left: 34px;

    width: 564px;
    height: 170px;
  }
  .preview-text2{
    position: absolute;
    top: 835px;
    left: 200px;

    width: 396px;
    height: 226px;
  }
  .preview-title{
    margin: 12px 10px 7px; 
    line-height: 1;
    font-family: title_l2;
    font-size: 28px;
    color: #aab9d7;
  }
  .preview-content{
    margin: 7px 10px;
    line-height: 24px;
    font-size: 18px;
    color: #aab9d7;
  }

  /* AI朗读按钮 */
  .player-btn{
    position: absolute;
    top: 18.6rem;
    right: .82rem;
    z-index: 15;
    width: 1.1rem;
    height: 1.1rem;
    background-size: 100%;
  }
  .player-btn-play{
    background-image: url(../assets/p4/play.png);
  }
  .player-btn-pause{
    z-index: 20;
    background-image: url(../assets/p4/pause.png);
  }

  /* 按钮区域，还有底图 */
  .content{
    position: absolute;
    top: 11.5rem;
    z-index: 8;
    width: 20rem;
    height: 27.1rem;
    background-image: url(../assets/p4/content.png);
    background-size: 100% 100%;
  }
  .help-btn, .retryr-btn, .choujiang-btn{
    position: absolute;
    top: 17.9rem;
    height: 1.875rem;
    background-size: 100%;
  }
  .help-btn{
    left: 2.53rem;
    width: 4.5rem;
    background-image: url(../assets/p6/share.png);
  }
  .choujiang-btn{
    left: 2.22rem;
    width: 5.1875rem;
    background-image: url(../assets/p4/choujiang.png);
  }
  .retryr-btn{
    right: 4.1rem;
    width: 4.5rem;
    background-image: url(../assets/p4/retry.png);
  }

  .ai-logo {
    position: absolute;
    top: 4.72rem;
    right: .5rem;
    z-index: 2;

    width: 1.75rem;
    height: 2.25rem;
    background-image: url(../assets/p4/AI-logo.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .anim-fade{
    animation: animfade 1.2s linear infinite;
    -webkit-animation: animfade 1.2s linear infinite;
  }
  @-webkit-keyframes animfade{
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.1;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes animfade{
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }


  /* 引导分享 */
  .lead-to-share{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    font-size: 1.5rem;
    color: #ffffff;
  }
  .lead-to-share img{
    position: absolute;
    top: .75rem;
    left: .75rem;
    width: 18.03rem;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
